// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-plan {
  display: flex;
  margin-top: 30px;
  justify-content: center;
}

.feature-plan .feature {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 10px;
  line-height: 10px;
  color: #727272;
}

.feature-plan .feature + .feature {
  margin-left: 30px;
}

.feature-plan .feature .feature-name {
  margin-left: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.feature-plan.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".feature-plan {\n  display: flex;\n  margin-top: 30px;\n  justify-content: center;\n}\n\n.feature-plan .feature {\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 10px;\n  color: #727272;\n}\n\n.feature-plan .feature + .feature {\n  margin-left: 30px;\n}\n\n.feature-plan .feature .feature-name {\n  margin-left: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
